import { ResponseObject, CompanyData, OfferResponse, CategoryData, SearchResponse, FooterResponse, UpperFooter, MetaResponse, WidgetResponse, EventResponse, EventDetailsResponse, EventBannerResponse, DisclaimerResponse, FooterPageResponse, Template, Faqs, FaqPageResponse, minimalMerchantData, ContactPageResponse, MetaKeywordsResponse, CategoryWithSub, SuggestedCategoriesResponse, CategoryOffers, Promotion, PromotionDetailsResponse, PromotionBannerResponse, EventMerchant, PromotionCategoryResponse, HomeMultiProducts, Offer, ProductData, ProductCategory, ProductCategoryData, NotFound, BrandedMerchant, MerchantProductsResponse, BrandedProductsResponse, CategoryFaq, CategoryFaqData, ProductsCategoryData, RobotsTxtResponse, LlmsTxtResponse, ProductSearchResponse, PromotionFaq, EventFaq, InternalBlogResponse, BlogResponse, BlogCategoryResponse, } from '@services/dataTypes';
import apiService, { NAV_REVALIDATE } from '@services/ApiService';
import { cache } from 'react';


export const apiCategoryData = async (company_id: string): Promise<ResponseObject<CategoryData[]>> => {
	const response = await apiService.post<CategoryData[]>('/company/get_category', { company_id });
	return response;
};

export const apiSearchResult = async (query: string, company_id: string): Promise<ResponseObject<SearchResponse>> => {
	const response = await apiService.post<SearchResponse>('/company/search', { query, company_id });
	return response;
};

export const apiProductSearchResult = async (query: string, company_id: string): Promise<ResponseObject<ProductSearchResponse>> => {
	const response = await apiService.post<ProductSearchResponse>('/company/search_products', { query, company_id });
	return response;
};

export const apiGetCategoryUniqueId = async (data: string, company_id: string): Promise<ResponseObject<CategoryData>> => {
	const response = await apiService.post<CategoryData>('/company/get_category_detail_by_type', { data, company_id });
	return response;
};

export const apiGetCategoryFAQS = async (domain: string, category_id: string): Promise<ResponseObject<CategoryFaq[]>> => {
	const response = await apiService.post<CategoryFaq[]>('/company/get_category_page_faqs', { domain, category_id });
	return response;
};

export const apiCategoryFAQS = async (domain: string, category_id: string): Promise<ResponseObject<CategoryFaqData>> => {
	const response = await apiService.post<CategoryFaqData>('/company/get_new_category_page_faqs', { domain, category_id });
	return response;
};

export const apiGetProductCategoryUniqueId = async (data: string, company_id: string): Promise<ResponseObject<ProductCategoryData>> => {
	const response = await apiService.post<ProductCategoryData>('/company/get_product_category_detail_by_type', { data, company_id });
	return response;
};

const apiCompanyUpdatedDataByDomain = cache(async (domain: string): Promise<ResponseObject<CompanyData>> => {
	return apiService.post<CompanyData>('/company/get_company_data', { domain });
});

export const apiCompanyUpdatedData = async (data: { domain: string }): Promise<ResponseObject<CompanyData>> => {
	return apiCompanyUpdatedDataByDomain(data.domain);
};

export const apiExpiredOffers = async (merchant_id: string, company_id: string): Promise<ResponseObject<OfferResponse>> => {
	const response = await apiService.post<OfferResponse>('/company/get_expired_offers', { merchant_id, company_id });
	return response;
};

export const apiGetKeywords = async (merchant_id: string, company_id: string): Promise<ResponseObject<any>> => {
	const response = await apiService.post<any>('/company/get_meta_value', { merchant_id, company_id });
	return response;
};
export const apiFooter = cache(async (company_id: string): Promise<ResponseObject<FooterResponse[]>> => {
	const response = await apiService.post<FooterResponse[]>('/company/get_blog', { company_id });
	return response;
});

export const apiGetUpperFooter = async (company_id: string): Promise<ResponseObject<UpperFooter>> => {
	const response = await apiService.post<UpperFooter>('/company/get_upper_footer', { company_id });
	return response;
};

export const apiOutUrl = async (company_id: string, id: string): Promise<ResponseObject<any>> => {
	const response = await apiService.post<any>('/company/out_URL', { company_id, id });
	return response;
};

export const apiMostSearch = async (company_id: string): Promise<ResponseObject<any>> => {
	const response = await apiService.post<any>('/company/get_search_data', { company_id });
	return response;
};

export const apiGetAllKeywords = async (company_id: string): Promise<ResponseObject<any>> => {
	const response = await apiService.post<any>('/company/get_meta_keywords', { company_id });
	return response;
};

export const apiGetAllUpdatedKeywords = async (domain: string): Promise<ResponseObject<MetaKeywordsResponse[]>> => {
	const response = await apiService.get<MetaKeywordsResponse[]>('/company/get_meta_updated_keywords', { domain });
	return response;
};

export const apiSearchStore = async (query: string, company_id: string): Promise<ResponseObject<SearchResponse>> => {
	const response = await apiService.post<SearchResponse>('/company/search_store', { query, company_id });
	return response;
};

export const apiGetMetaData = cache(async (data: string, domain: string): Promise<ResponseObject<MetaResponse>> => {
	return apiService.get<MetaResponse>('/company/get_meta_details', { data, domain });
});

export const apiGetWidgets = cache(async (domain: string): Promise<ResponseObject<WidgetResponse>> => {
	return apiService.get<WidgetResponse>('/company/get_company_widgets', { domain });
});

export const apiGetEvents = async (company_id: string): Promise<ResponseObject<EventResponse[]>> => {
	const response = await apiService.get<EventResponse[]>('/company/get_events', { company_id }, NAV_REVALIDATE);
	return response;
};

export const apiGetEventsFaqs = async (company_id: string, event_slug: string): Promise<ResponseObject<EventFaq>> => {
	const response = await apiService.post<EventFaq>('/company/get_event_faqs', { company_id, event_slug });
	return response;
};


export const apiGetEventDetails = async (company_id: string, slug: string): Promise<ResponseObject<EventDetailsResponse>> => {
	const response = await apiService.get<EventDetailsResponse>('/company/get_event_merchants_and_offers', { company_id, slug });
	return response;
};

export const apiGetHomeEventDetails = async (company_id: string): Promise<ResponseObject<EventDetailsResponse>> => {
	const response = await apiService.post<EventDetailsResponse>('/company/get_home_page_event_offers', { company_id });
	return response;
};

export const apiGetEventBanners = async (company_id: string, slug: string): Promise<ResponseObject<EventBannerResponse[]>> => {
	const response = await apiService.get<EventBannerResponse[]>('/company/get_event_banners', { company_id, slug });
	return response;
};

export const apiGetDisclaimer = async (domain: string): Promise<ResponseObject<DisclaimerResponse>> => {
	const response = await apiService.get<DisclaimerResponse>('/company/get_disclaimer', { domain });
	return response;
};

export const apiFooterPagesData = async (domain: string, slug: string): Promise<ResponseObject<FooterPageResponse>> => {
	const response = await apiService.get<FooterPageResponse>('/company/get_footer_pages', { domain, slug });
	return response;
};

export const apiTemplate = cache(async (domain: string): Promise<ResponseObject<Template>> => {
	return apiService.get<Template>('/company/get_template', { domain });
});

export const apiHomePageFaqs = async (domain: string): Promise<ResponseObject<Faqs[]>> => {
	const response = await apiService.get<Faqs[]>('/company/get_home_page_faqs', { domain });
	return response;
};

export const apiFaqPage = async (domain: string): Promise<ResponseObject<FaqPageResponse>> => {
	const response = await apiService.get<FaqPageResponse>('/company/get_faq_page', { domain });
	return response;
};

export const apiRecentlyUpdatedStores = async (domain: string): Promise<ResponseObject<minimalMerchantData[]>> => {
	const response = await apiService.get<minimalMerchantData[]>('/company/get_latest_updated_merchant', { domain });
	return response;
};

export const apiContactForm = async (domain: string, name: string, number: string, email: string, message: string): Promise<ResponseObject<any>> => {
	const response = await apiService.post<any>('/company/add_contact_us_list', { domain, name, number, email, message });
	return response;
};

export const apiContactPage = async (domain: string): Promise<ResponseObject<ContactPageResponse>> => {
	const response = await apiService.get<ContactPageResponse>('/company/get_company_us_page_details', { domain });
	return response;
};

export const apiCategoryWithSub = async (company_id: string): Promise<ResponseObject<CategoryWithSub[]>> => {
	const response = await apiService.post<CategoryWithSub[]>('/company/get_new_category', { company_id });
	return response;
};

export const apiCategoryOffers = async (category_id: string, company_id: string, page: number): Promise<ResponseObject<CategoryOffers>> => {
	const response = await apiService.post<CategoryOffers>('/company/get_offer_category_wise', { category_id, company_id, page });
	return response;
};

export const apiCategoryOfferBanners = async (category_id: string, company_id: string, page: number): Promise<ResponseObject<OfferResponse>> => {
	const response = await apiService.post<OfferResponse>('/company/get_banner_offer_category_wise', { category_id, company_id, page });
	return response;
};

export const apiSuggestedCategory = async (category_id: string): Promise<ResponseObject<SuggestedCategoriesResponse>> => {
	const response = await apiService.post<SuggestedCategoriesResponse>('/company/get_suggested_categories', { category_id });
	return response;
};

export const apiGetAllProducts = async (company_id: string, category_id?: string, page?: string, per_page: number = 30): Promise<ResponseObject<OfferResponse>> => {
	const response = await apiService.post<OfferResponse>('/company/get_all_products', { company_id, category_id, page, per_page });
	return response;
};

export const apiGetAllEvents = async (domain: string): Promise<ResponseObject<EventResponse[]>> => {
	const response = await apiService.get<EventResponse[]>('/company/get_all_events', { domain });
	return response;
};

export const apiGetAllPromotion = async (domain: string): Promise<ResponseObject<Promotion[]>> => {
	const response = await apiService.get<Promotion[]>('/company/get_all_promotions', { domain }, NAV_REVALIDATE);
	return response;
};

export const apiGetPromotionDetails = async (company_id: string, slug: string): Promise<ResponseObject<PromotionDetailsResponse>> => {
	const response = await apiService.get<PromotionDetailsResponse>('/company/get_promotion_merchants_and_offers', { company_id, slug });
	return response;
};

export const apiGetPromotionBanners = async (company_id: string, slug: string): Promise<ResponseObject<PromotionBannerResponse[]>> => {
	const response = await apiService.get<PromotionBannerResponse[]>('/company/get_promotion_banners', { company_id, slug });
	return response;
};

export const apiGetPromotionSuggestedMerchants = async (company_id: string, slug: string): Promise<ResponseObject<EventMerchant[]>> => {
	const response = await apiService.post<EventMerchant[]>('/company/get_promotion_suggested_merchants', { company_id, slug });
	return response;
};

export const apiGetPromotionOfferBanners = async (company_id: string, slug: string): Promise<ResponseObject<PromotionDetailsResponse>> => {
	const response = await apiService.get<PromotionDetailsResponse>('/company/get_promotion_offer_banners', { company_id, slug });
	return response;
};

export const apiGetPromotionCategories = async (company_id: string, slug: string): Promise<ResponseObject<PromotionCategoryResponse>> => {
	const response = await apiService.get<PromotionCategoryResponse>('/company/get_promotion_category', { company_id, slug });
	return response;
};

export const apiGetPromotionFaqs = async (company_id: string, promotion_id: string): Promise<ResponseObject<PromotionFaq>> => {
	const response = await apiService.post<PromotionFaq>('/company/get_promotion_faqs', { company_id, promotion_id });
	return response;
};


export const apiGetMultiProductOffers = async (company_id: string): Promise<ResponseObject<HomeMultiProducts>> => {
	const response = await apiService.post<HomeMultiProducts>('/company/get_home_page_popular_products', { company_id });
	return response;
};

export const apiGetProductMerchants = cache(async (company_id: string): Promise<ResponseObject<minimalMerchantData[]>> => {
	const response = await apiService.post<minimalMerchantData[]>('/company/get_products', { company_id });
	return response;
});

export const apiCheckBrandedMerchants = async (company_id: string, slug: string): Promise<BrandedMerchant> => {
	const response = await apiService.post<BrandedMerchant>('/company/check_merchant_branded_status', { company_id, slug });
	return response as unknown as BrandedMerchant;
};

export const apiGetMerchantProducts = async (company_id: string, slug: string): Promise<ResponseObject<ProductData[]>> => {
	const response = await apiService.post<ProductData[]>('/company/get_product_merchant', { company_id, slug });
	return response;
};

export const apiGetUpdatedMerchantProducts = async (company_id: string, slug: string, page: number = 1): Promise<ResponseObject<MerchantProductsResponse>> => {
	const response = await apiService.post<MerchantProductsResponse>('/company/get_new_product_merchant', { company_id, slug, page });
	return response;
};


// export const apiHomeBrandedProducts = async (company_id: string): Promise<ResponseObject<BrandedProductsResponse>> => {
// 	const response = await apiService.post<BrandedProductsResponse>('/company/get_brand_latest_products', { company_id });
// 	return response;
// };

export const apiHomeBrandedProducts = async (company_id: string, page: number = 1, per_page: number = 10): Promise<ResponseObject<BrandedProductsResponse>> => {
	const response = await apiService.post<BrandedProductsResponse>('/company/get_brand_latest_products', { company_id, page, per_page });
	return response;
};

export const apiGetCategoryProducts = async (company_id: string, slug: string): Promise<ResponseObject<ProductCategory[]>> => {
	const response = await apiService.post<ProductCategory[]>('/company/get_product_category', { company_id, slug });
	return response;
};

// old 
export const apiGetCategoryProductsOffer = async (company_id: string, slug: string, category_slug: string): Promise<ResponseObject<ProductData[]>> => {
	const response = await apiService.post<ProductData[]>('/company/get_product_by_category', { company_id, slug, category_slug });
	return response;
};
// new updated response with faq and heading 
export const apiGetNewCategoryProductsOffer = async (company_id: string, slug: string, category_slug: string): Promise<ResponseObject<ProductsCategoryData>> => {
	const response = await apiService.post<ProductsCategoryData>('/company/get_product_by_category_new', { company_id, slug, category_slug });
	return response;
};

export const apiGetProductDetails = async (company_id: string, product_id: string, store_slug: string): Promise<ResponseObject<Offer>> => {
	const response = await apiService.post<Offer>('/company/get_product_detail', { company_id, product_id, store_slug });
	return response;
};

export const api404NotFound = async (domain: string, url: string): Promise<ResponseObject<NotFound>> => {
	const response = await apiService.post<NotFound>('/company/company_404_request', { domain, url });
	return response;
};

export const apiRobotTxt = async (domain: string): Promise<RobotsTxtResponse> => {
	// This endpoint returns RobotsTxtResponse flat (not wrapped in ResponseObject like other endpoints)
	const response = await apiService.post<RobotsTxtResponse>('/company/get_robots_txt', { domain });
	return response as unknown as RobotsTxtResponse;
};

export const apiLlmTxt = async (domain: string): Promise<LlmsTxtResponse> => {
	// This endpoint returns RobotsTxtResponse flat (not wrapped in ResponseObject like other endpoints)
	const response = await apiService.post<LlmsTxtResponse>('/company/get_llms_txt', { domain });
	return response as unknown as LlmsTxtResponse;
};

export const apiAllBlogs = cache(async (company_id: string, page: number = 1): Promise<BlogResponse> => {
	const response = await apiService.post<BlogResponse>('/company/get_blogs', { company_id, page });
	return response as unknown as BlogResponse;
});

export const apiInternalBlogs = async (company_id: string, slug: string): Promise<InternalBlogResponse> => {
	const response = await apiService.post<InternalBlogResponse>('/company/get_blog_detail', { company_id, slug });
	return response as unknown as InternalBlogResponse;
};

export const apiAllCategories = async (company_id: string): Promise<BlogCategoryResponse> => {
	const response = await apiService.post<BlogCategoryResponse>('/company/get_blog_categories', { company_id });
	return response as unknown as BlogCategoryResponse;
};
